import React from "react";
import { Button, Col, Container, FormGroup, Row, Label } from "reactstrap";
import FormTextInput from "../../../../components/form/text-input";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store/rootReducer";
import { useLoadingMessage } from "../../../../components/useLoadingMessage";
import { PageBody } from "../../../../components/Loader";
import { ResponsecropTypeType } from "../../../../models/config.model";
import { configService } from "../../../../Services";
import { configThunk } from "../../../../redux/action/config/config.thunk";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { useAlert } from "react-alert";
import { FaSpinner } from "react-icons/fa";
import Layout from "../../../../components/Layout";

interface FormValues {
  associationName: string;
  cropId: string;
  presidentName: string;
  PhoneNumber: string;
}
const Create_association = () => {
  const { isLoading, message, updateLoader } = useLoadingMessage();
  const { cropType } = useSelector((state: RootState) => state.cropType);
  const dispatch = useDispatch();
  const alert = useAlert();
  const history = useHistory();
  const phoneValidate =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const initialValues: FormValues = {
    associationName: "",
    cropId: "",
    presidentName: "",
    PhoneNumber: "",
  };
  const getroles = React.useCallback(async () => {
    updateLoader(true, "Fetching Data");
    await dispatch(configThunk.getAllCropType(cropType));
    updateLoader(false, "");
  }, [cropType]);

  React.useEffect(() => {
    getroles();
  }, []);

  return (
    <PageBody isLoading={isLoading} message={message}>
      <Layout active="Config">
        <Container>
          <Row>
            <Col>
              <Formik
                initialValues={initialValues}
                validationSchema={Yup.object({
                  associationName: Yup.string().required("Name is required"),
                  cropId: Yup.string().required(" Crop is required"),
                  presidentName: Yup.string().required(
                    " President name required"
                  ),
                  PhoneNumber: Yup.string()
                    .required("phone number is a required field")
                    .max(11, "phone number must be 14 digits maximum")
                    .min(10, "phone number must be 11 digits minimum")
                    .matches(phoneValidate, "Phone number is not valid"),
                })}
                onSubmit={async (values, actions) => {
                  console.log({ values, actions });

                  actions.setSubmitting(true);
                  try {
                    const response = await configService.createAssociation(
                      values
                    );
                    alert.success("successfully created");
                    history.push("/config");
                    actions.setSubmitting(false);
                  } catch (error: any) {
                    alert.error(error.response.data.message);
                    actions.setSubmitting(false);
                  }
                }}
              >
                {({ errors, touched, isSubmitting, handleChange, values }) => (
                  <Form>
                    <Row>
                      <Col>
                        <FormGroup className="">
                          <Label className="font-weight-bold">
                            Association Name{" "}
                            <span className="text-danger fw-bold">*</span>{" "}
                          </Label>
                          <Field
                            type="text"
                            label="Name"
                            placeholder="enter name"
                            name="associationName"
                            className="form-control form-control-lg"
                            valid
                          />
                          {touched.associationName && errors.associationName ? (
                            <div className="text-danger">
                              {errors.associationName}
                            </div>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup className="">
                          <Label className="font-weight-bold">
                            Crop <span className="text-danger fw-bold">*</span>{" "}
                          </Label>
                          <Field
                            name="cropId"
                            as="select"
                            className="form-control form-control-lg"
                          >
                            <option> select</option>
                            {cropType
                              .filter((cropTypes: any) => cropTypes.isActive)
                              .map((crp: ResponsecropTypeType, i) => (
                                <option value={crp.id}>{crp.name}</option>
                              ))}
                          </Field>
                          {touched.cropId && errors.cropId ? (
                            <div className="text-danger">{errors.cropId}</div>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row className="">
                      <Col>
                        <FormGroup className="">
                          <Label className="font-weight-bold">
                            President Name{" "}
                            <span className="text-danger fw-bold">*</span>
                          </Label>
                          <Field
                            type="text"
                            label="President"
                            placeholder="enter president's name"
                            name="presidentName"
                            className="form-control form-control-lg"
                            valid
                          />
                          {touched.presidentName && errors.presidentName ? (
                            <div className="text-danger">
                              {errors.presidentName}
                            </div>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup className="">
                          <Label className="font-weight-bold">
                            President Number{" "}
                            <span className="text-danger fw-bold">*</span>
                          </Label>
                          <Field
                            type="text"
                            label="President's Phone"
                            placeholder="enter phone number"
                            name="PhoneNumber"
                            className="form-control form-control-lg"
                            valid
                          />
                          {touched.PhoneNumber && errors.PhoneNumber ? (
                            <div className="text-danger">
                              {errors.PhoneNumber}
                            </div>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>

                    <div className="p-3 text-center">
                      <Link to="/config">
                        <Button
                          color="success"
                          className="btn-cancel px-4 py-2 shadow font-weight-bold m-5"
                        >
                          Cancel
                        </Button>
                      </Link>
                      <Button
                        type="submit"
                        color="success"
                        className="btn-create px-4 py-2 shadow font-weight-bold"
                        disabled={isSubmitting}
                      >
                        Create
                        {isSubmitting ? (
                          <FaSpinner className="fa-spin" />
                        ) : null}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </Container>
      </Layout>
    </PageBody>
  );
};

export default Create_association;
